import React, { PureComponent } from 'react';
import 'css/ViewEventListItem.scss';
import { browserHistory, withRouter } from 'react-router';
import ViewMainMarkets from 'components/ViewMainMarkets';
import ViewVinderspilMarkets from './ViewVinderspilMarkets';
import classNames from 'classnames';
import {
    APP_PATH,
    EVENT_STATUS,
    MARKET_STATUS,
    MARKET_TYPE_GROUPS_ID,
    SPORTS,
} from 'constants/appConfig';
import { formatPlayerName, isMarketOverUnder } from 'utils/Helper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as LiveEventsActions from 'actions/LiveEventsActions';
import * as UiActions from 'actions/UiActions';
import { UI_INFO_MESSAGE } from 'constants/ui';
import { detectMobile, formatDate, isTerminal } from 'utils/UiHelper';
import liveIcon from 'images/icons/live_icon.svg';
import { trackEvents } from '../helpers/VaixHelpers/VaixTracking';
import {
    VAIX_TRACKING_LOCATION_FOR_TYPE_OF_SPORT,
    VAIX_TRACKING_TYPE,
} from '../constants/vaix/VaixTrcakingConstants';
import Wrapper from '../ui/Wrapper';

class ViewEventListItem extends PureComponent {
    longPress = null;
    isPressActivated = false;
    setScoresEventIds = [
        SPORTS.TENNIS,
        SPORTS.BADMINTON,
        SPORTS.TABLE_TENNIS,
        SPORTS.VOLLEYBALL,
        SPORTS.BEACH_VOLLEY,
    ];
    gamesWithMarketName = [SPORTS.HESTESPORT, SPORTS.SPECIALS_ALT];
    state = {
        opened: false,
    };

    unsubscribeToFirebaseMarketChanges = () => {};

    openGamePage(eventObj) {
        if (eventObj && eventObj?.vaixIndex && eventObj?.vaixIndex > 0) {
            trackEvents(
                eventObj,
                VAIX_TRACKING_TYPE.clickEvent,
                VAIX_TRACKING_LOCATION_FOR_TYPE_OF_SPORT(eventObj.sport),
                '/live',
                this.props.userId,
                0,
                eventObj?.vaixIndex
            );
        }

        if (eventObj.live && eventObj.status <= 0) {
        } else {
            browserHistory.push('/sport/kamp/' + eventObj.eventId);
        }
    }

    /**
     * @param {EventModel} ev
     * @returns {Node}
     */
    _getScoreBySets(ev) {
        if (!ev.liveScore) {
            return (
                <div className="event-score-by-sets">
                    <div className="event-set-score">
                        <div className="score-value home">0</div>
                        <div className="score-value away">0</div>
                    </div>
                </div>
            );
        }

        if (
            ev.liveScore.scorePartList &&
            ev.liveScore.scorePartList.length > 0
        ) {
            const currentSet =
                ev.liveScore.scorePartList[
                    ev.liveScore.scorePartList.length - 1
                ];
            const homeGameScore =
                ev.liveScore.extraInfo && ev.liveScore.extraInfo.HomeGameScore
                    ? ev.liveScore.extraInfo.HomeGameScore
                    : null;
            const awayGameScore =
                ev.liveScore.extraInfo && ev.liveScore.extraInfo.AwayGameScore
                    ? ev.liveScore.extraInfo.AwayGameScore
                    : null;
            const [homeScore, awayScore] = currentSet.score.split(':');
            return (
                <div className="event-score-by-sets">
                    <div className="event-set-score active-score">
                        <div className="score-value home">
                            {ev.liveScore && ev.liveScore.homeScore}
                        </div>
                        <div className="score-value away">
                            {ev.liveScore && ev.liveScore.awayScore}
                        </div>
                    </div>
                    <div className="event-set-score">
                        <div
                            className="score-value home"
                            title={currentSet.part}
                        >
                            {homeScore}
                        </div>
                        <div
                            className="score-value away"
                            title={currentSet.part}
                        >
                            {awayScore}
                        </div>
                    </div>
                    {ev.sportId === SPORTS.TENNIS &&
                        homeGameScore &&
                        awayGameScore && (
                            <div className="event-set-score">
                                <div
                                    className="score-value home"
                                    title={currentSet.part}
                                >
                                    {homeGameScore}
                                </div>
                                <div
                                    className="score-value away"
                                    title={currentSet.part}
                                >
                                    {awayGameScore}
                                </div>
                            </div>
                        )}
                </div>
            );
        }

        if (ev.sportId === SPORTS.TABLE_TENNIS) {
            const setScores = (ev.liveScore.partScores || '').split(' - ');
            const lastScore = setScores[setScores.length - 1] || '0:0';
            const [homeSetScore, awaySetScore] = lastScore.split(':');
            return (
                <div className="event-score-by-sets">
                    <div className="event-set-score active-score">
                        <div className="score-value home">
                            {ev.liveScore && ev.liveScore.homeScore}
                        </div>
                        <div className="score-value away">
                            {ev.liveScore && ev.liveScore.awayScore}
                        </div>
                    </div>
                    {!!ev.liveScore.partScores ? (
                        <div className="event-set-score">
                            <div className="score-value home">
                                {homeSetScore}
                            </div>
                            <div className="score-value away">
                                {awaySetScore}
                            </div>
                        </div>
                    ) : (
                        <div className="event-set-score">
                            <div className="score-value home">-</div>
                            <div className="score-value away">-</div>
                        </div>
                    )}
                </div>
            );
        }
        return (
            <div className="event-score-by-sets">
                <div className="event-set-score">
                    <div className="score-value home">
                        {ev.liveScore && ev.liveScore.homeScore}
                    </div>
                    <div className="score-value away">
                        {ev.liveScore && ev.liveScore.awayScore}
                    </div>
                </div>
            </div>
        );
    }

    getRedCards(ev, teamIndex) {
        if (
            ev.sportId === SPORTS.FOOTBALL &&
            ev.liveScore &&
            (ev.liveScore.homeRedCard || ev.liveScore.awayRedCard)
        ) {
            return ev.liveScore.homeRedCard > 0 && teamIndex === '1' ? (
                <svg
                    style={{ marginLeft: '2px' }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                >
                    <rect
                        id="Rectangle_336"
                        data-name="Rectangle 336"
                        width="8"
                        height="12"
                        rx="2"
                        fill="#e24e4e"
                    />
                </svg>
            ) : ev.liveScore.awayRedCard > 0 && teamIndex === '2' ? (
                <svg
                    style={{ marginLeft: '2px' }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                >
                    <rect
                        id="Rectangle_336"
                        data-name="Rectangle 336"
                        width="8"
                        height="12"
                        rx="2"
                        fill="#e24e4e"
                    />
                </svg>
            ) : null;
        }
    }

    _getTeamName(ev, teamIndex) {
        if (
            ev.sportId === SPORTS.TENNIS &&
            ev.liveScore &&
            ev.liveScore.extraInfo &&
            teamIndex === ev.liveScore.extraInfo.server
        ) {
            return (
                <div className="extra-info">
                    <div className="active-player-name">
                        {teamIndex === '1'
                            ? formatPlayerName(ev.homeTeam)
                            : formatPlayerName(ev.awayTeam)}
                    </div>

                    <img
                        className="active-player-icon"
                        src={APP_PATH + '/img/sports/5.png'}
                        width="10"
                        height="10"
                        alt="5"
                    />
                </div>
            );
        } else if (
            ev.sportId === SPORTS.FOOTBALL &&
            ev.liveScore &&
            (ev.liveScore.homeRedCard || ev.liveScore.awayRedCard)
        ) {
            return (
                <div className="extra-info">
                    <div className="active-player-name">
                        {teamIndex === '1' ? ev.homeTeam : ev.awayTeam}
                    </div>
                    {this.getRedCards(ev, teamIndex)}
                </div>
            );
        } else {
            return (
                <div className="three-dots">
                    {teamIndex === '1'
                        ? formatPlayerName(ev.homeTeam)
                        : formatPlayerName(ev.awayTeam)}
                    {this.getRedCards(ev, teamIndex)}
                </div>
            );
        }
    }

    toggleViderspil() {
        this.setState({
            opened: !this.state.opened,
        });
    }

    getMarketCountLabel() {
        let showCount =
            this.props?.event?.marketList?.[0] &&
            this.props.event.marketList.some(
                (item) => item.marketTypeGroup === MARKET_TYPE_GROUPS_ID._1X2
            )
                ? 1
                : 0;

        if (
            this.props.event.sportId === SPORTS.FOOTBALL &&
            !detectMobile() &&
            this.props.event?.marketList?.[0] &&
            this.props.event.marketList.some(isMarketOverUnder)
        ) {
            showCount += 1;
        }
        const marketsLeftCount = this.props.event.marketCount - showCount;
        return marketsLeftCount > 0 ? `+${marketsLeftCount}` : '';
    }

    /**
     * @param {EventModel} ev
     * @returns {Node|null}
     */
    getLiveTime(ev) {
        if (ev.sportId === SPORTS.TENNIS) {
            return null;
        }
        if (ev.sportId === SPORTS.FOOTBALL) {
            if (ev.liveScore && ev.liveScore.time !== -1) {
                return (
                    <div className="live-time">
                        {ev.liveScore &&
                        ev.liveScore.time === 45 &&
                        ev.liveScore.status === 'paused' ? (
                            'HT'
                        ) : (
                            <i>{ev.liveScore.time + "'"}</i>
                        )}
                    </div>
                );
            }
            return (
                <div className="live-time">
                    <i>-</i>
                </div>
            );
        }
        if (ev.liveScore && ev.liveScore.time && ev.liveScore.time !== -1) {
            return (
                <div className="live-time">
                    <i>{ev.liveScore.time + "'"}</i>
                </div>
            );
        }
        return null;
    }

    onPressStartHandler() {
        this.isPressActivated = true;

        setTimeout(() => {
            this.longPress = true;

            if (this.isPressActivated) {
                this.isPressActivated = false;

                //this.onLongPressHandler();
            }
        }, 1500);

        return true;
    }

    onPressEndHandler(event) {
        if (this.longPress && this.isPressActivated) {
            this.longPress = false;

            //this.onLongPressHandler();

            event.preventDefault();

            return false;
        }

        this.isPressActivated = false;

        return true;
    }

    onLongPressHandler() {
        if (isTerminal()) return; // disable favoriting games on terminals (they disappear)

        const eventId = this.props.event.eventId;
        this.props.liveEventsActions.addFavorite(eventId);
        this.props.liveEventsActions.animationStatus(true);

        setTimeout(() => {
            this.props.liveEventsActions.animationStatus(false);
        }, 1000);
    }

    showInfoNotification = (text, e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.uiActions.notification(UI_INFO_MESSAGE, text);
    };

    isLivePageLocation() {
        return this.props.location.pathname === '/live';
    }

    componentWillUnmount() {
        this.unsubscribeToFirebaseMarketChanges();
    }

    /**
     *
     * @param ev
     * @param marketList
     * @param itemList
     * @return {*}
     */

    getVinderspilView = (ev, marketList, itemList) => {
        if (this.state.opened) {
            return itemList.map((item, index) => (
                <div
                    key={index}
                    className={
                        !detectMobile() && itemList.length > 1 ? 'col-5' : ''
                    }
                >
                    <div className="p2">
                        <ViewVinderspilMarkets
                            disabled={
                                marketList.status !== MARKET_STATUS.ACTIVE ||
                                ev.status !== EVENT_STATUS.IN_PROGRESS
                            }
                            market={marketList}
                            ev={ev}
                            item={item}
                            live={ev.live ? '1' : '0'}
                        />
                    </div>
                </div>
            ));
        } else {
            if (marketList) {
                return itemList.slice(0, 8).map((item, index) => (
                    <div
                        key={index}
                        className={
                            !detectMobile() && itemList.length > 1
                                ? 'col-5'
                                : ''
                        }
                    >
                        <div className="p2">
                            <ViewVinderspilMarkets
                                disabled={
                                    marketList.status !==
                                        MARKET_STATUS.ACTIVE ||
                                    ev.status !== EVENT_STATUS.IN_PROGRESS
                                }
                                market={marketList}
                                ev={ev}
                                item={item}
                                live={ev.live ? '1' : '0'}
                            />
                        </div>
                    </div>
                ));
            }
            return null;
        }
    };

    /**
     *
     * @param marketList
     * @param ev
     * @return {JSX.Element}
     */
    getVinderspilTemplate = (marketList, ev) => {
        return marketList.map((market, index) => {
            const itemList = market?.itemList
                ? market?.itemList.filter((item) => item.odds > 1)
                : [];

            return (
                <div
                    className="view-event-list-item vinderspil"
                    key={market.marketId}
                >
                    <div
                        className="row cursor-pointer"
                        onClick={this.openGamePage.bind(this, ev)}
                    >
                        <div
                            className={
                                this.getMarketCountLabel() &&
                                marketList.length === 1
                                    ? 'col-8'
                                    : 'col-9'
                            }
                        >
                            <div className="event-names p10">
                                <div className="event-name">
                                    {ev?.sportId === SPORTS.HESTESPORT
                                        ? ev?.marketList[index].marketName
                                        : ev?.eventName}
                                </div>

                                {market?.freeText ? (
                                    <div className="small-info-text">
                                        <i>({market?.freeText})</i>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        {this.getMarketCountLabel() &&
                        marketList.length === 1 ? (
                            <div className="col-1 ">
                                <div
                                    className="text-right p10 event-names f14 grey"
                                    style={{ paddingTop: '11px' }}
                                >
                                    {this.getMarketCountLabel()}
                                </div>
                            </div>
                        ) : null}
                        <div className="col-1 text-center">
                            <div className="p10 grey">
                                <i
                                    className="fa fa-chevron-right"
                                    aria-hidden="true"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="p10">
                        <div className={!detectMobile() ? 'row' : ''}>
                            {this.getVinderspilView(ev, market, itemList)}
                        </div>
                        {itemList && itemList.length > 8 ? (
                            <div
                                className="lnk text-center f12 m10"
                                onClick={this.toggleViderspil.bind(this)}
                            >
                                {!this.state.opened
                                    ? 'Se alle deltagere'
                                    : 'Se mindre deltagere'}
                            </div>
                        ) : null}
                    </div>
                </div>
            );
        });
    };

    render() {
        const isPrePage = () => {
            return window.location.pathname === '/sport/pre';
        };
        /**
         * @type {EventModel} ev
         */
        const ev = this.props.event;

        const marketList = ev.marketList
            ? ev.marketList.filter(
                  (market) =>
                      (market.marketName &&
                          market.marketName.toUpperCase() === '1X2') ||
                      ev.defaultMarketId === market.marketId ||
                      market.mainMarket === 1 ||
                      (market.marketTypeGroupName &&
                          market.marketTypeGroupName.toUpperCase() === '1X2')
              )
            : null;

        if (
            (ev.homeTeam && ev.homeTeam !== 'N/A') ||
            (marketList &&
                marketList?.[0] &&
                marketList?.[0]?.marketTypeName?.indexOf('Vinderspil') === -1 &&
                marketList?.[0]?.marketTypeName?.indexOf('H2H') === -1)
        ) {
            if (ev.live) {
                return (
                    <div
                        className={classNames(
                            'view-event-list-item row noselect live-event-item',
                            {
                                tennis: ev.sportId === SPORTS.TENNIS,
                                mobile: detectMobile(),
                            }
                        )}
                        onContextMenu={null}
                        onTouchStart={this.onPressStartHandler.bind(this)}
                        onTouchEnd={this.onPressEndHandler.bind(this)}
                    >
                        {((!detectMobile() && this.getLiveTime(ev)) ||
                            (!detectMobile() && ev?.streamId)) && (
                            <div className="event-score-time col-1">
                                {this.getLiveTime(ev) && this.getLiveTime(ev)}
                                <div className={'wrapperIcon'}>
                                    {ev?.streamId && (
                                        <img
                                            src={liveIcon}
                                            alt=""
                                            className={'desktopLiveIcon'}
                                        />
                                    )}
                                </div>
                            </div>
                        )}

                        <div
                            className="event-names col-25"
                            onClick={this.openGamePage.bind(this, ev)}
                        >
                            <div className="event-name">
                                {this._getTeamName(ev, '1')}
                            </div>
                            <div className="event-name">
                                {this._getTeamName(ev, '2')}
                            </div>

                            {detectMobile() && (
                                <div className="event-score-time">
                                    {this.getLiveTime(ev)}

                                    {ev?.streamId && (
                                        <img
                                            src={liveIcon}
                                            alt=""
                                            className={`mobileLiveIcon ${
                                                ev.sportId === 20
                                                    ? 'tennis'
                                                    : ''
                                            }`}
                                        />
                                    )}

                                    {this.getMarketCountLabel() && (
                                        <div className="market-count">
                                            ({this.getMarketCountLabel()})
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {!this.setScoresEventIds.includes(ev.sportId) ? (
                            <div className="live-score-col single-score col-05 row">
                                <div
                                    className={classNames({
                                        'disabled-time': !(
                                            ev.liveScore &&
                                            ev.liveScore.time !== -1
                                        ),
                                    })}
                                    onClick={this.openGamePage.bind(this, ev)}
                                >
                                    <div className="event-score three-dots">
                                        {ev?.liveScore
                                            ? ev.liveScore.homeScore
                                            : 0}
                                    </div>
                                    <div className="event-score three-dots">
                                        {ev?.liveScore
                                            ? ev.liveScore.awayScore
                                            : 0}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            this._getScoreBySets(ev)
                        )}

                        <div
                            className={classNames('event-main-markets', {
                                'col-5': !detectMobile(),
                                'col-50':
                                    detectMobile() && this.isLivePageLocation(),
                                'col-55':
                                    detectMobile() &&
                                    !this.isLivePageLocation(),
                            })}
                        >
                            <ViewMainMarkets
                                disabled={
                                    ev.status !== EVENT_STATUS.IN_PROGRESS ||
                                    (marketList?.[0] &&
                                        marketList?.[0].status !==
                                            MARKET_STATUS.ACTIVE)
                                }
                                ev={ev}
                                market={marketList?.[0]}
                                live={ev.live ? '1' : '0'}
                                header={this.props.header}
                            />
                        </div>

                        {!detectMobile() && (
                            <div className="link-show-all-markets col-1 cursor-pointer">
                                <span
                                    onClick={this.openGamePage.bind(this, ev)}
                                >
                                    {this.getMarketCountLabel()}
                                </span>
                            </div>
                        )}
                    </div>
                );
            } else {
                return (
                    <div>
                        <div
                            className={classNames(
                                'view-event-list-item row pr10',
                                {
                                    mobile: detectMobile(),
                                }
                            )}
                        >
                            <div
                                className={classNames('event-col-meta', {
                                    'col-40': !detectMobile(),
                                    'col-45': detectMobile(),
                                })}
                            >
                                <div
                                    className="event-names"
                                    onClick={this.openGamePage.bind(this, ev)}
                                >
                                    <div className="event-name">
                                        {this._getTeamName(ev, '1')}
                                        {marketList[0] &&
                                            marketList[0].freeText && (
                                                <i
                                                    className="fa fa-info-circle blue cursor-pointer"
                                                    aria-hidden="true"
                                                    title={
                                                        marketList[0].freeText
                                                    }
                                                    onClick={(e) => {
                                                        this.showInfoNotification(
                                                            marketList[0]
                                                                .freeText,
                                                            e
                                                        );
                                                    }}
                                                />
                                            )}
                                    </div>
                                    <div className="event-name">
                                        {this._getTeamName(ev, '2')}
                                    </div>
                                </div>

                                <div className="event-score-time pl10">
                                    <div className="live-time-col">
                                        <div className="live-time live-date">
                                            {formatDate(ev.kickoff, 'DD/MM')}
                                        </div>
                                        <div className="live-time live-hours">
                                            {formatDate(ev.kickoff, 'HH:mm')}
                                        </div>
                                        {detectMobile() &&
                                            this.getMarketCountLabel() && (
                                                <div className="market-count">
                                                    (
                                                    {this.getMarketCountLabel()}
                                                    )
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>

                            <div
                                className={classNames('event-main-markets', {
                                    'col-5': !detectMobile(),
                                    'col-55': detectMobile(),
                                })}
                            >
                                <ViewMainMarkets
                                    market={marketList[0]}
                                    ev={ev}
                                    live={ev.live ? '1' : '0'}
                                    header={this.props.header}
                                />
                            </div>

                            {!detectMobile() && (
                                <div
                                    className="link-show-all-markets col-1"
                                    onClick={this.openGamePage.bind(this, ev)}
                                >
                                    <span>{this.getMarketCountLabel()}</span>
                                </div>
                            )}
                        </div>
                    </div>
                );
            }
        } else {
            return !isPrePage()
                ? this.getVinderspilTemplate(marketList, ev)
                : null;
        }
    }
}

function mapStateToProps(state) {
    return { liveEvents: state.liveEvents };
}

function mapDispatchToProps(dispatch) {
    return {
        liveEventsActions: bindActionCreators(LiveEventsActions, dispatch),
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(ViewEventListItem)
);
